
export default function PartnersHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#e10708] to-[#c00607] py-24">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-6">
            <i className="ri-team-line text-3xl"></i>
          </div>
          <h1 className="text-5xl font-bold mb-6">Our Trusted Partners</h1>
          <p className="text-xl text-red-50 leading-relaxed">
            We collaborate with industry-leading experts to provide comprehensive solutions for your medical practice. Each partner brings specialized expertise to help your practice thrive.
          </p>
        </div>
      </div>
    </section>
  );
}
